export default __webpack_public_path__ + "static/media/clockinjs.04d8a60a.png";